import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";
import { pdsrUrls } from "../../../../URL/ApplicationUrls";
import { MdmApiError } from "../../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../../Errors/apiErrorNotificationToast";

export const useDeletePdsrs = () => {
  return useMutation({
    mutationFn: (pdsrIds: number[]) => {
      return axios.delete(pdsrUrls.base.apiUrl, { data: pdsrIds });
    },
    onSuccess: async () => {
      toast.success("PDSR(s) successfully deleted");
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
